export { default, type TeamListProps } from './TeamList';
